import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js'

// 常用地區置頂，其餘依繁中國名排序。清單本體由 libphonenumber-js 產生，不手動維護，
// 避免硬編清單漏掉冷門國家（實測 245 個地區 / 206 個國碼）。
// 順序與 bd-system-frontend 的 PREFERRED_REGIONS 保持一致，方便兩系統對照。
const PREFERRED_REGIONS = ['TW', 'JP', 'US', 'CA', 'HK', 'MO', 'CN', 'KR', 'SG', 'MY', 'VN', 'TH', 'AU', 'GB']

const regionDisplayNames = new Intl.DisplayNames(['zh-TW'], { type: 'region' })

// [{ region: 'TW', code: '+886', label: '台灣 +886' }, ...]
export const COUNTRY_CODES = (() => {
  const all = getCountries().map(region => ({
    region,
    code: `+${getCountryCallingCode(region)}`,
    label: `${regionDisplayNames.of(region) || region} +${getCountryCallingCode(region)}`
  }))
  const preferred = PREFERRED_REGIONS
    .map(r => all.find(item => item.region === r))
    .filter(Boolean)
  const rest = all
    .filter(item => !PREFERRED_REGIONS.includes(item.region))
    .sort((a, b) => a.label.localeCompare(b.label, 'zh-Hant'))
  return [...preferred, ...rest]
})()

// 檢查當地手機格式是否能轉成 OTP 查詢所需格式。
export function isValidLocalPhone(region, localPhone) {
  return buildOtpQueryPhone(region, localPhone) !== null
}

// 產生 OTP 查詢用手機；台灣保留 09 開頭 10 碼，其他地區轉成 E.164。
// 第一個參數是 region（ISO code，如 'TW'、'US'）而非國碼字串，
// 因為有「一碼多國」的情況（+1 對應 25 個地區），需要 region 才能正確驗證。
export function buildOtpQueryPhone(region, localPhone) {
  if (typeof localPhone !== 'string') return null

  if (region === 'TW') {
    // 送給後端的值一律是 09 開頭 10 碼；使用者省略開頭 0 時由前端補回。
    if (/^09\d{8}$/.test(localPhone)) return localPhone
    if (/^9\d{8}$/.test(localPhone)) return `0${localPhone}`
    return null
  }

  const phoneNumber = parsePhoneNumberFromString(localPhone, region)
  if (!phoneNumber || !phoneNumber.isValid()) return null

  return phoneNumber.format('E.164')
}
